import React from "react";
import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";

import nurtureBg from "../assets/uploads/bg.jpg";

const features = [
  "Qualified, Experienced & Caring Teachers",
  "Smart Classrooms with Digital Boards",
  "Fully Air Conditioned Campus",
  "Activity Based Learning Environment",
  "Well Equipped Language Laboratory",
  "Indoor & Outdoor Sports Facilities",
  "Swimming Pool Training",
  "Safe & Secure Transport Facility",
  "Sibling Fee Concession",
  "Admissions Open",
];

const NurturingTalents = () => {
  return (
   <section
  className="relative overflow-hidden bg-cover bg-center py-16"
      style={{
        backgroundImage: `url(${nurtureBg})`,
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#07294d]/55"></div>

      {/* Golden Glow */}
      <div className="absolute -top-24 -left-24 w-72 h-72 bg-[#d4af37]/10 rounded-full blur-[100px]"></div>
      <div className="absolute -bottom-24 -right-24 w-72 h-72 bg-[#d4af37]/10 rounded-full blur-[100px]"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-5">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <h2 className="text-white text-3xl md:text-5xl font-bold leading-tight">
            Nurturing Talents
            <span className="block text-[#d4af37] mt-2">
              For A Bright Future
            </span>
          </h2>

          <div className="w-20 h-1 bg-[#d4af37] rounded-full mx-auto mt-5"></div>
        </motion.div>

        {/* Features */}
        <div className="grid md:grid-cols-2 gap-4 max-w-5xl mx-auto">
          {features.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.5,
                delay: index * 0.05,
              }}
              viewport={{ once: true }}
              className="flex items-center gap-4 rounded-xl border border-white/20 bg-white/10 backdrop-blur-sm px-5 py-4 hover:bg-white/15 transition-all duration-300"
            >
              <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-[#d4af37]">
                <FaCheckCircle
                  className="text-[#07294d]"
                  size={15}
                />
              </div>

              <p className="text-white text-[15px] font-medium leading-6">
                {item}
              </p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default NurturingTalents;
